import React, { useState } from 'react';

import { DownOutlined } from '@ant-design/icons';
import {
  Button as AntdButton,
  Dropdown as AntdDropdown,
  Menu as AntdMenu,
} from 'antd';

import {
  AutoriteFourriereDto,
  ConditionsReactivateAutoriteFourriereDto,
} from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';

import CommentairesField from '../Modals/CommentairesField';
import ModalDesactivation from '../Modals/ModalDesactivation/ModalDesactivation';
import ModalReactivation, {
  ConditionReactivateProps,
} from '../Modals/ModalReactivation/ModalReactivation';

import ConditionReactivateAutoriteFourriere from './ConditionReactivateAutoriteFourriere/ConditionReactivateAutoriteFourriere';
import ModalDetails from './Modals/ModalDetails';
import ModalUpdate from './Modals/ModalUpdate';
import UsesAutoriteFourriere from './UsesAutoriteFourriere/UsesAutoriteFourriere';
import { useChangeValidityAutoriteFourriere } from './utils';

import './CellDetailsAndActions.less';

interface CellDetailsAndActionsProps {
  autorite: AutoriteFourriereDto;
  refreshDashboard: () => void;
}

function CellDetailsAndActions({
  autorite,
  refreshDashboard,
}: CellDetailsAndActionsProps): React.ReactElement {
  const [isDetailsOpen, setIsDetailsOpen] = useState<boolean>(false);
  const [isUpdateOpen, setIsUpdateOpen] = useState<boolean>(false);
  const [isChangeValidityOpen, setIsChangeValidityOpen] =
    useState<boolean>(false);
  const controller = useApi().AdminFonctionnelControllerApi;

  const [currentCommentaires, setCurrentCommentaires] = useState<string | null>(
    autorite.commentaires,
  );

  const [
    submitReactivateReferentiel,
    submitDeprecateReferentiel,
    conditionsReactivateReferentiel,
    getUsesRequest,
  ] = useChangeValidityAutoriteFourriere(controller, currentCommentaires);

  const conditionUnlock = (
    conditions: ConditionsReactivateAutoriteFourriereDto | undefined,
  ): boolean => {
    return conditions?.reactivationAvailable ?? false;
  };

  const closeUpdateValidity = () => {
    setIsChangeValidityOpen(false);
  };

  const menu = (
    <AntdMenu>
      <AntdMenu.Item
        onClick={() => {
          setIsUpdateOpen(true);
        }}
      >
        Modifier
      </AntdMenu.Item>
      <AntdMenu.Item
        onClick={() => {
          setIsChangeValidityOpen(true);
        }}
      >
        {autorite.enabled ? "Désactiver l'autorité" : "Réactiver l'autorité"}
      </AntdMenu.Item>
    </AntdMenu>
  );

  return (
    <>
      <AntdButton
        onClick={() => {
          setIsDetailsOpen(true);
        }}
      >
        Détails
      </AntdButton>
      <AntdDropdown overlay={menu} className="menuActions">
        <AntdButton>
          Actions <DownOutlined />
        </AntdButton>
      </AntdDropdown>
      <ModalDetails
        autorite={autorite}
        visible={isDetailsOpen}
        close={() => {
          setIsDetailsOpen(false);
        }}
      />
      <ModalUpdate
        refreshDashboard={refreshDashboard}
        autorite={autorite}
        visible={isUpdateOpen}
        close={() => {
          setIsUpdateOpen(false);
        }}
      />
      {isChangeValidityOpen &&
        (autorite.enabled ? (
          <ModalDesactivation
            idCorrelation={autorite.idCorrelation}
            titleModal="Désactiver l'autorité de fourrière"
            usesRequest={getUsesRequest}
            submitDeprecate={submitDeprecateReferentiel}
            componentUses={UsesAutoriteFourriere}
            visible={isChangeValidityOpen}
            close={closeUpdateValidity}
            callAfterSubmit={refreshDashboard}
          >
            <CommentairesField
              currentCommentaires={currentCommentaires}
              setCurrentCommentaires={setCurrentCommentaires}
            />
          </ModalDesactivation>
        ) : (
          <ModalReactivation
            idCorrelation={autorite.idCorrelation}
            titleModal="Réactiver l'autorité de fourrière"
            visible={isChangeValidityOpen}
            close={closeUpdateValidity}
            callAfterSubmit={refreshDashboard}
            conditionRequest={conditionsReactivateReferentiel}
            componentConditions={({
              conditions,
            }: ConditionReactivateProps<ConditionsReactivateAutoriteFourriereDto>) => {
              return (
                <ConditionReactivateAutoriteFourriere
                  autorite={autorite}
                  conditions={conditions}
                />
              );
            }}
            conditionUnlock={conditionUnlock}
            reactivateRequest={submitReactivateReferentiel}
          >
            <CommentairesField
              currentCommentaires={currentCommentaires}
              setCurrentCommentaires={setCurrentCommentaires}
            />
          </ModalReactivation>
        ))}
    </>
  );
}

export default CellDetailsAndActions;
